import React, { useEffect, useRef, useState } from "react";
import { ArcherContainer, ArcherElement } from "react-archer";
import features from "../../assets/features5.webm"; // Ensure this path is correct
import poster from "../../assets/poster.avif";   // Ensure this path is correct
import "../../styles/animatedSection.css"; // Your CSS file

const AnimatedSection = () => {
  const videoRef = useRef(null);
  const [activeSection, setActiveSection] = useState("");
  const [showArrows, setShowArrows] = useState(false); // State to control arrow visibility/animation

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      const t = video.currentTime;

      // Adjust these timestamps based on your video content
      if (t >= 0 && t < 4) { // Assuming Dashboard is the first segment
        setActiveSection("dashboard");
      } else if (t >= 4 && t < 37) { // Route To Market segment
        setActiveSection("route");
      } else if (t >= 37 && t < 65) { // Geofence segment
        setActiveSection("geofence");
      } else if (t >= 65) { // Analytics  segment
        setActiveSection("analytics");
      }
    };

    const handleContextMenu = (e) => e.preventDefault(); // block right-click

    video.addEventListener("timeupdate", handleTimeUpdate);
    video.addEventListener("contextmenu", handleContextMenu);

    // Set a timeout to show arrows after a brief delay, allowing initial render
    const arrowTimer = setTimeout(() => {
      setShowArrows(true);
    }, 100); // Adjust delay as needed

    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
      video.removeEventListener("contextmenu", handleContextMenu);
      clearTimeout(arrowTimer);
    };
  }, []);

  return (
    <ArcherContainer strokeColor="#ccc" strokeWidth={2}>
      <div className="video-flow-container">
        {/* Top Row Boxes - NOW define their relations to the video */}
        <div className="box-row top-row">
          <ArcherElement
            id="dashboard"
            relations={[
              {
                targetId: "video",
                sourceAnchor: "bottom", // Arrow originates from Dashboard's bottom edge
                targetAnchor: "top",    // Points to video's top edge
                className: activeSection === "dashboard" && showArrows ? "active-arrow" : "",
                style: { strokeDashoffset: activeSection === "dashboard" ? 0 : 400 },
              },
            ]}
          >
            <div
              className={`box ${activeSection === "dashboard" ? "active" : ""}`}
            >
              <i className="bx bx-package" />
              Dashboard
            </div>
          </ArcherElement>

          <ArcherElement
            id="route"
            relations={[
              {
                targetId: "video",
                sourceAnchor: "bottom", // Arrow originates from Route's bottom edge
                targetAnchor: "top",    // Points to video's top edge
                className: activeSection === "route" && showArrows ? "active-arrow" : "",
                style: { strokeDashoffset: activeSection === "route" ? 0 : 400 },
              },
            ]}
          >
            <div className={`box ${activeSection === "route" ? "active" : ""}`}>
              <i className="bx bx-sitemap"></i>
              Route To Market
            </div>
          </ArcherElement>
        </div>

        {/* Video Element - NO relations here anymore */}
        <ArcherElement id="video">
          <div
            className={`video-wrapper ${activeSection ? "active-border" : ""}`}
          >
            <video
              ref={videoRef}
              src={features}
              autoPlay
              muted
              loop
              preload="metadata"
              poster={poster}
              controlsList="nodownload"
              className="video-player"
            />
          </div>
        </ArcherElement>

        {/* Bottom Row Boxes - NOW define their relations to the video */}
        <div className="box-row bottom-row">
          <ArcherElement
            id="analytics"
            relations={[
              {
                targetId: "video",
                sourceAnchor: "top",    // Arrow originates from Analytics' top edge
                targetAnchor: "bottom", // Points to video's bottom edge
                className: activeSection === "analytics" && showArrows ? "active-arrow" : "",
                style: { strokeDashoffset: activeSection === "analytics" ? 0 : 400 },
              },
            ]}
          >
            <div
              className={`box ${activeSection === "analytics" ? "active" : ""}`}
            >
              <i className="bx bx-chart" />
              Analytics
            </div>
          </ArcherElement>

          <ArcherElement
            id="geofence"
            relations={[
              {
                targetId: "video",
                sourceAnchor: "top",    // Arrow originates from Geofence's top edge
                targetAnchor: "bottom", // Points to video's bottom edge
                className: activeSection === "geofence" && showArrows ? "active-arrow" : "",
                style: { strokeDashoffset: activeSection === "geofence" ? 0 : 400 },
              },
            ]}
          >
            <div
              className={`box ${activeSection === "geofence" ? "active" : ""}`}
            >
              <i className="bx bx-map-pin"></i>
              Geofencing
            </div>
          </ArcherElement>
        </div>
      </div>
    </ArcherContainer>
  );
};

export default AnimatedSection;